import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";
import { runBackgroundRequest } from "../utils/backgroundRequestQueue";

const EMPTY_EVENT_HOST_ATTENTION = {
  waitlist: { total_unread: 0, unread_events_count: 0, events: [] },
  participant_requests: { total_unread: 0, unread_events_count: 0, events: [] },
};

const EventHostAttentionContext = createContext(null);

export const EventHostAttentionProvider = ({
  children,
  enabled = true,
  intervalMs = 60_000,
  userId = null,
}) => {
  const { data, refetch } = useQuery({
    queryKey: ["event_host_attention_summary", userId],
    enabled: Boolean(enabled),
    queryFn: async () => {
      const response = await runBackgroundRequest(() => (
        api.get("/events/host-attention-summary/", {
          meta: { suppressGlobalError: true },
        })
      ));
      return response?.data || EMPTY_EVENT_HOST_ATTENTION;
    },
    refetchInterval: intervalMs,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

  const value = useMemo(
    () => ({
      data: data || EMPTY_EVENT_HOST_ATTENTION,
      refetch,
    }),
    [data, refetch]
  );

  return (
    <EventHostAttentionContext.Provider value={value}>
      {children}
    </EventHostAttentionContext.Provider>
  );
};

export const useEventHostAttention = () => (
  useContext(EventHostAttentionContext) || {
    data: EMPTY_EVENT_HOST_ATTENTION,
    refetch: async () => {},
  }
);
